var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "miniProduct" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-4" }, [
        _vm.mainImage
          ? _c("img", {
              staticClass: "lazyload img-fluid",
              attrs: { "data-src": _vm.mainImage, alt: _vm.title }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-8" }, [
        _c("strong", [
          _vm.referenceTitle
            ? _c("span", [_vm._v(_vm._s(_vm.referenceTitle) + " - ")])
            : _vm._e(),
          _vm._v(_vm._s(_vm.title))
        ]),
        _vm._v(" "),
        "site.repository.product_reference" === _vm.type ||
        "site.repository.fidelity_gift" === _vm.type
          ? _c("span", [_vm._v("Quantité : " + _vm._s(_vm.quantity))])
          : _vm._e(),
        _vm._v(" "),
        "site.repository.product_reference" === _vm.type
          ? _c("span", { staticClass: "prix" }, [
              _vm._v(_vm._s(_vm._f("moneyFormat")(_vm.total)) + " "),
              _vm.unitsTotal != _vm.total
                ? _c("del", [
                    _vm._v(_vm._s(_vm._f("moneyFormat")(_vm.unitsTotal)))
                  ])
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        "site.repository.fidelity_gift" === _vm.type
          ? _c("span", { staticClass: "prix" }, [
              _vm._v(_vm._s(_vm.total) + " points fidélité")
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23e4adaa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23e4adaa","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/SiteBundle/Resources/assets/components/CartWidgetItem.vue
// module id = 522
// module chunks = 1